import React, {useCallback} from 'react';
import {Link} from 'react-router-dom';
import Particles from 'react-tsparticles';
import {loadSlim} from 'tsparticles-slim';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiPhone, FiMail, FiMapPin, FiFacebook, FiInstagram, FiLinkedin} = FiIcons;

const Footer = () => {
  const particlesInit = useCallback(async (engine) => {
    await loadSlim(engine);
  }, []);

  // Dynamisches Jahr für Copyright
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white relative overflow-hidden">
      <div className="absolute inset-0 z-0 pointer-events-none opacity-30">
        <Particles
          id="footer-particles"
          init={particlesInit}
          options={{
            fullScreen: {
              enable: false,
            },
            background: {
              color: {
                value: "transparent",
              },
            },
            fpsLimit: 120,
            interactivity: {
              detectsOn: "canvas",
              events: {
                onClick: {
                  enable: true,
                  mode: "push",
                },
                onHover: {
                  enable: true,
                  mode: "grab",
                },
                resize: true,
              },
              modes: {
                grab: {
                  distance: 150,
                  links: {
                    opacity: 0.5,
                  },
                },
                push: {
                  quantity: 4,
                },
              },
            },
            particles: {
              color: {
                value: "#ffffff",
              },
              links: {
                color: "#ffffff",
                distance: 150,
                enable: true,
                opacity: 0.2,
                width: 1,
              },
              move: {
                direction: "none",
                enable: true,
                outModes: {
                  default: "bounce",
                },
                random: false,
                speed: 0.8,
                straight: false,
              },
              number: {
                density: {
                  enable: true,
                  area: 800,
                },
                value: 60,
              },
              opacity: {
                value: 0.3,
              },
              shape: {
                type: "circle",
              },
              size: {
                value: {min: 1, max: 3},
              },
            },
            detectRetina: true,
          }}
          className="w-full h-full"
        />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 relative z-10 pointer-events-none">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 *:pointer-events-auto">
          {/* Company Info */}
          <div className="space-y-6 pointer-events-auto">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-gradient-to-br from-[#3466ad] to-[#2a5291] rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">R</span>
              </div>
              <div>
                <h3 className="text-xl font-bold">RUDT Bau</h3>
                <p className="text-sm text-gray-400">Rohbau · Klinker · Putz</p>
              </div>
            </div>
            <p className="text-gray-400 leading-relaxed">
              Ihr zuverlässiger Partner für alle Bauarbeiten. Qualität, Präzision und Handwerk seit über 10 Jahren.
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-[#3466ad] transition-colors"
              >
                <SafeIcon icon={FiFacebook} className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-[#3466ad] transition-colors"
              >
                <SafeIcon icon={FiInstagram} className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-[#3466ad] transition-colors"
              >
                <SafeIcon icon={FiLinkedin} className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="pointer-events-auto">
            <h4 className="text-lg font-semibold mb-6">Navigation</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white transition-colors">
                  Startseite
                </Link>
              </li>
              <li>
                <Link to="/leistungen" className="text-gray-400 hover:text-white transition-colors">
                  Leistungen
                </Link>
              </li>
              <li>
                <Link to="/ueber-uns" className="text-gray-400 hover:text-white transition-colors">
                  Über uns
                </Link>
              </li>
              <li>
                <Link to="/referenzen" className="text-gray-400 hover:text-white transition-colors">
                  Referenzen
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="text-gray-400 hover:text-white transition-colors">
                  Kontakt
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div className="pointer-events-auto">
            <h4 className="text-lg font-semibold mb-6">Leistungen</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/leistungen/rohbau" className="text-gray-400 hover:text-white transition-colors">
                  Rohbau
                </Link>
              </li>
              <li>
                <Link to="/leistungen/klinkerarbeiten" className="text-gray-400 hover:text-white transition-colors">
                  Klinkerarbeiten
                </Link>
              </li>
              <li>
                <Link to="/leistungen/putzarbeiten" className="text-gray-400 hover:text-white transition-colors">
                  Putzarbeiten
                </Link>
              </li>
              <li>
                <Link to="/leistungen/betonarbeiten" className="text-gray-400 hover:text-white transition-colors">
                  Betonarbeiten
                </Link>
              </li>
              <li>
                <Link to="/leistungen/maurerarbeiten" className="text-gray-400 hover:text-white transition-colors">
                  Maurerarbeiten
                </Link>
              </li>
              <li>
                <Link to="/leistungen/pflasterverlegung" className="text-gray-400 hover:text-white transition-colors">
                  Pflasterverlegung
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="pointer-events-auto">
            <h4 className="text-lg font-semibold mb-6">Kontakt</h4>
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiPhone} className="w-5 h-5 text-[#3466ad]" />
                <a
                  href="tel:+4924528607019"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  02452 860 70 19
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiMail} className="w-5 h-5 text-[#3466ad]" />
                <a
                  href="mailto:info@rudtbau.de"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  info@rudtbau.de
                </a>
              </div>
              <div className="flex items-start space-x-3">
                <SafeIcon icon={FiMapPin} className="w-5 h-5 text-[#3466ad] mt-0.5" />
                <div className="text-gray-400">
                  <p>Wassenbergerstr. 41</p>
                  <p>52525 Heinsberg</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 pointer-events-auto">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {currentYear} RUDT Bau. Alle Rechte vorbehalten.
            </p>
            <div className="flex space-x-6 text-sm text-gray-400">
              <Link to="/impressum" className="hover:text-white transition-colors">
                Impressum
              </Link>
              <Link to="/datenschutz" className="hover:text-white transition-colors">
                Datenschutz
              </Link>
              <Link to="/agb" className="hover:text-white transition-colors">
                AGB
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;